import React, { useState, useRef, useLayoutEffect, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { Card } from "primereact/card";
import { bookPageRows, bookRowsPerPageOptions } from "./common/envBook";
import { getDataApi1, loadApi, saveApi} from "../services/appApi";
import axios from "axios";
import "../assets/css/grid_table.css";
import "../assets/css/card.css";

const GlAccounts  = () => {

  let emptyRow = {
   gl_account_template_desc:null,
  gl_account_template_id:null,
  gl_account_template_name:"Sole Prop"
  };



  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [row, setRow] = useState(emptyRow);
  const [showproductDialog, setShowProductDialog] = useState(false);
  const [selectedRows, setSelectedRows] = useState(null);
  const [globalFilter, setGlobalFilter] = useState(null);  
  const [errorDialogVisible, setErrorDialogVisible] = useState(false);
  const [apiErrorDialog, setApiErrorDialog] = useState(sessionStorage.getItem("bookSessionExpired") === "true");
  const [errorMessage, setErrorMessage] = useState('');
  



  const toast = useRef(null);
  const dt = useRef(null);
  
  const fetchStarted = useRef(false);
 

    const fetchRows = async () => {
      try {
        let offset = 0;
        let limit = 25;
        let hasMore = true;
        let allData = [];
        let status = null;
        setIsLoading(true);
        while (hasMore) {
       
        
        const response = await getDataApi1("/ords/book/zbk_gl_account_templates_v/");
        console.log(response)
        allData = [...allData, ...response.data.items];
        status =  response.status;
        hasMore = response.hasMore;
        offset = offset + limit;
        }
        if (status === 200 && !hasMore) {
          if (allData.length > 0) {
             toast.current.show({
              severity: 'success',
              summary: 'Success',
              detail: 'Data fetched successfully'
            })
            setRows(allData);
            setIsLoading(false);
          } else {
            
            setRows([]);
            setIsLoading(false);
          }
          //setSearch(response.data);
        } else {
          //setRows(null);
          setRows([]);
          setIsLoading(false);
          const errorInfo = "Error";

            // Set the error message and display the dialog
          setErrorMessage(errorInfo);
          setErrorDialogVisible(true);
        }

        //setRows(response.data);
      } catch (error) {
        if(axios.isCancel(error) ||  error.name=== 'CanceledError') {
        toast.current.show({
          severity: 'warn',
          summary: 'Cancelled',
          detail: 'Request successfully cancelled by the user.',
          life: 3000,
        })
        setIsLoading(false);
      } else {
           // Set the error message and display the dialog
            setErrorMessage(error.message);
            setErrorDialogVisible(true);
      }
    }
    };
  useLayoutEffect(() => {
     if(!fetchStarted.current){
    fetchStarted.current=true
    fetchRows();
     }
  }, []);


  ///////////Doubt
  const hideDialog = () => {
    setShowProductDialog(false);
    //setShowProductDtlDialog(false);
    setErrorDialogVisible(false);
  };



  const showProduct = (row) => {
    setRow({ ...row });
    setShowProductDialog(true);
}

const exportCSV = () => {
  dt.current.exportCSV();
};

const getLoadingHeaderContents = () => {
  return (
    <React.Fragment>
      <div className="flex justify-content-center align-items-center min-h-screen p-5">
        <Card className="w-full sm:w-30rem shadow-3 border-1 border-primary overflow-hidden">
            <div style={{backgroundColor: 'var(--primary-color'}} className="text-white p-3 text-center border-round-top">
                <h2 className="m-0">Gl Accounts Table</h2>
            </div>
            <div className="p-4 text-center bg-white">
                <h3 className="text-900 m-0">The Page is loading...</h3>
            </div>
        </Card>
      </div>
    </React.Fragment>
  );
}
const getLoadedHeaderContents = () => {
                return (
                  <React.Fragment>
                    <div className="header-container">
                      <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                      Gl Accounts
                      </h2>
                      {/* <h2 className="text-center my-3 d-flex flex-column flex-md-row align-items-center justify-content-center">
                        <div className="header-container p-1">
                            <style>
                            {`
                              input::placeholder {
                                font-size: 17px; 
                              }
                            `}
                          </style>
                        <span className="p-input-icon-right w-full md:w-auto"> 
                      <InputText
                        type="search"
                        onInput={(e) => setGlobalFilter(e.target.value)}
                        placeholder="Search..."
                        className="w-full lg:w-auto text-sm p-3"
                        style={{ fontSize: '17px' }} 
                      /> 
                    </span>
                        </div>
                      </h2>*/}
                    </div>
                  </React.Fragment>
                );
              }

  const header = (
    
    <div className="flex flex-column md:flex-row md:align-items-center justify-content-between">
      
      {/* <span className="p-input-icon-right w-full md:w-auto">
        <InputText
          type="search"
          onInput={(e) => setGlobalFilter(e.target.value)}
          placeholder="Search..."
          className="w-full lg:w-auto"
        />
      </span> */}
      <div className="mt-1 md:mt-0 flex md:flex-1 justify-content-end">
        <Button
          icon="pi pi-upload"
          className="p-button-primary p-button-rounded"
          onClick={exportCSV}
          tooltip="Export"
          tooltipOptions={{ position: "bottom" }}
        />
      </div>
    </div>
  );


  const readBodyTemplate = (rowData) => {
    return (
      <React.Fragment>
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-primary"
          onClick={() => showProduct(rowData)}
          tooltip="View"
          tooltipOptions={{ position: "bottom" }}
        />
      </React.Fragment>
    );
  };

  

  return (
    <div>
      <Toast ref={toast} />
      <div className="col mx-2">
      {isLoading ? getLoadingHeaderContents() : getLoadedHeaderContents()}
      {!isLoading && (
      <div className="card mb-3">
        {/* <div className="text-3xl text-800 font-bold mb-4"> Firm Clients</div> */}
        <DataTable
          ref={dt}
          value={rows}
          scrollable scrollHeight="flex"     
          selection={selectedRows}
          onSelectionChange={(e) => setSelectedRows(e.value)}
          dataKey="firm_client_id"
          className="custom-datatable-border"
          tableStyle={{ minWidth: '50rem' }}
          paginator
          rows={bookPageRows}
          rowsPerPageOptions={bookRowsPerPageOptions}
          paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords} data"
          globalFilter={globalFilter}
          header={header}
          emptyMessage="No data found"
          stripedRows
          showGridlines
          removableSort


          ////dubt
          /* //expandedRows={expandedRowId.map((firm_client_id) =>
                rows.find((rows) => rows.firm_client_id === firm_client_id)
              )}
              onRowToggle={(e) => {
                const rowId = e.data ? e.data.firm_client_id : null;
                setExpandedRowId((prev) =>
                  prev.includes(rowId)
                    ? prev.filter((firm_client_id) => firm_client_id !== rowId)
                    : [...prev, rowId]
                );
              }}
           */        
        >
         
          <Column body={readBodyTemplate} exportable={false} style={{width:'0.75rem' }}></Column> 
          <Column field="gl_account_template_name" header="Name" bodyStyle={{ textAlign: "left" }} sortable></Column>
          <Column field="gl_account_template_desc" header="Description" sortable></Column>
          {/* <Column field="gl_account_template_id" header="ID" sortable></Column> */}
          
        </DataTable>
      </div>
      )}

      <Dialog visible={showproductDialog} style={{ width: '37.5rem' }} header="Gl Account" modal className="p-fluid" onHide={hideDialog}>
                
               {/*  <label htmlFor="client_legal_name">DEsc</label>
                    <div className="box">
                        {row.client_legal_name}
                    </div>

                <label htmlFor="federal_tax_id">Federal Tax ID</label>
                    <div className="box">
                        {row.federal_tax_id}
                    </div> */}        

                {/* <label htmlFor="gl_account_template_id">ID</label>
                    <div className="box">
                        {row.gl_account_template_id}
                    </div> */}

                <label htmlFor="gl_account_template_name">Name</label>
                    <div className="box">
                        {row.gl_account_template_name}
                    </div>    
                <label htmlFor="gl_account_template_desc">Description</label>
                    <div className="box">
                        {row.gl_account_template_desc}
                    </div>           

            </Dialog>


            
            {!apiErrorDialog && (
                        <Dialog 
                            header="API Error" 
                            visible={errorDialogVisible} 
                            style={{width: '25rem'}}
                            onHide={hideDialog} 
                            footer={
                                <Button label="OK" onClick={hideDialog} className="p-button-primary p-button-rounded" />
                            }
                        >    
                         <p>
            
                                {errorMessage}
                            </p>
                        </Dialog>
                        )}
            </div>
    </div>
  );
};

export default GlAccounts;

